import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4709f0de = () => interopDefault(import('..\\pages\\document-error.vue' /* webpackChunkName: "pages_document-error" */))
const _45a1bb35 = () => interopDefault(import('..\\pages\\eligibility.vue' /* webpackChunkName: "pages_eligibility" */))
const _20526030 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _81561aae = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _779be9b1 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _98a3f240 = () => interopDefault(import('..\\pages\\signature.vue' /* webpackChunkName: "pages_signature" */))
const _7e5d7938 = () => interopDefault(import('..\\pages\\ssuccess.vue' /* webpackChunkName: "pages_ssuccess" */))
const _e46896aa = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _5e23e309 = () => interopDefault(import('..\\pages\\timeout.vue' /* webpackChunkName: "pages_timeout" */))
const _1d1b7de4 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _34a2b2d1 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _34b0ca52 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _34ccf954 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _34db10d5 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _6988ee12 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _e8872af2 = () => interopDefault(import('..\\pages\\patient\\patient-information.vue' /* webpackChunkName: "pages_patient_patient-information" */))
const _3b8f6926 = () => interopDefault(import('..\\pages\\patient\\success.vue' /* webpackChunkName: "pages_patient_success" */))
const _da1b87e2 = () => interopDefault(import('..\\pages\\representative\\patient-information.vue' /* webpackChunkName: "pages_representative_patient-information" */))
const _440d46ae = () => interopDefault(import('..\\pages\\representative\\success.vue' /* webpackChunkName: "pages_representative_success" */))
const _46e77c0c = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/document-error",
    component: _4709f0de,
    name: "document-error"
  }, {
    path: "/eligibility",
    component: _45a1bb35,
    name: "eligibility"
  }, {
    path: "/error",
    component: _20526030,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _81561aae,
    name: "have-a-card"
  }, {
    path: "/rejection",
    component: _779be9b1,
    name: "rejection"
  }, {
    path: "/signature",
    component: _98a3f240,
    name: "signature"
  }, {
    path: "/ssuccess",
    component: _7e5d7938,
    name: "ssuccess"
  }, {
    path: "/success",
    component: _e46896aa,
    name: "success"
  }, {
    path: "/timeout",
    component: _5e23e309,
    name: "timeout"
  }, {
    path: "/upload-documents",
    component: _1d1b7de4,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _34a2b2d1,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _34b0ca52,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _34ccf954,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _34db10d5,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _6988ee12,
    name: "errors-500"
  }, {
    path: "/patient/patient-information",
    component: _e8872af2,
    name: "patient-patient-information"
  }, {
    path: "/patient/success",
    component: _3b8f6926,
    name: "patient-success"
  }, {
    path: "/representative/patient-information",
    component: _da1b87e2,
    name: "representative-patient-information"
  }, {
    path: "/representative/success",
    component: _440d46ae,
    name: "representative-success"
  }, {
    path: "/",
    component: _46e77c0c,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
